import { Divider, Skeleton, Stack } from "@mui/material";

type NotificationsListSkeletonProps = {
  rows?: number;
};

export default function NotificationsListSkeleton({
  rows = 3,
}: NotificationsListSkeletonProps) {
  return (
    <Stack spacing={2}>
      {Array.from({ length: rows }).map((_, index) => (
        <Stack key={`notification-skeleton-${index}`} gap={1}>
          <Stack direction="row" gap={1} alignItems="center">
            <Skeleton variant="text" width="55%" height={24} />
            <Skeleton variant="rounded" width={32} height={20} />
            <Skeleton variant="text" width={72} height={16} />
          </Stack>
          <Skeleton variant="text" width="100%" height={20} />
          <Skeleton variant="text" width="90%" height={20} />
          {index < rows - 1 && <Divider />}
        </Stack>
      ))}
    </Stack>
  );
}
